import styled from 'styled-components'
import { InputProps } from '@/themes/theme'
import WarningSvg from '@assets/icons/warning.svg'

export const TextInputWithErrorStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const TextInputStyled = styled.input<InputProps>`
  font-weight: 400;
  font-family: 'Inter', sans-serif;
  font-size: ${(props) => (props.$fontSize ? props.$fontSize : '14px')};
  line-height: ${(props) => (props.$lineHeight ? props.$lineHeight : '20px')};
  color: ${(props) => (props.$color ? props.$color : 'black')};
  padding: ${(props) => (props.$padding ? props.$padding : '10px 16px')};
  border: ${(props) => (props.$border ? props.$border : '0px')};
  border-radius: ${(props) => (props.$borderRadius ? props.$borderRadius : '0px')};

  &.error {
    border: ${(props) => (props.$error.$border ? props.$error.$border : '0px')};
    box-shadow: ${(props) => (props.$error.$boxShadow ? props.$error.$boxShadow : '0px')};
  }
`

export const ErrorStyled = styled.div<InputProps>`
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  line-height: 18px;
  color: ${(props) => (props.$error.$color ? props.$error.$color : 'red')};
  background: url(${WarningSvg}) no-repeat;
  padding: 0 0 0 22px;
`
